import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { html, TemplateResult } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';
import { WidgetStateFrontEnd } from '../../../../genericDashboard/gzGenericWidget/types';
import { styles } from '../view/styles';
import { WEB_COMPONENT_EASM_SERVICES_PER_PROTOCOL } from '../../../../webcomponents.constants';
import { GzEasmGenericTopDataWebComponent } from '../../genericTopData';
import { handleWidgetWithTopDataResize } from '../../../utils/utils';
import { MIN_NUMBER_OF_ROWS_TO_DISPLAY } from '../../constants';
import { FilterType } from '../../genericTopData/types/types';
import { translateFn } from '../../../../utils/translator.helper';
import { FindingClassType } from '../../../types';

@customElement(WEB_COMPONENT_EASM_SERVICES_PER_PROTOCOL)
export class GzEasmServicesPerProtocolWebComponent extends GzGenericWidgetContent {
  @property({
    type: WidgetStateFrontEnd,
    attribute: true,
    reflect: true,
  })
  state: WidgetStateFrontEnd;

  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: any;

  // This is used for widget resize handle
  @query('gz-easm-generic-top-data')
  private gzEASMGenericTopData: GzEasmGenericTopDataWebComponent;

  static get styles() {
    return styles;
  }

  public renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader> `;
  }

  public renderContent(): TemplateResult {
    const numberOfObjectsDisplayed = this.payload?.servicesPerProtocol?.rowsData
      ? Object.keys(this.payload?.servicesPerProtocol?.rowsData).length
      : 0;
    const totalAssets = this.payload?.servicesPerProtocol?.total;
    const textButton =
      totalAssets > 0
        ? translateFn('View all ({totalAssets})', {
            totalAssets,
          })
        : null;
    return html`
      <gz-easm-generic-top-data
        .rowsData=${this.payload?.servicesPerProtocol?.rowsData ?? []}
        .numberOfRowsToDisplay=${numberOfObjectsDisplayed}
        .minNumberOfRowsToDisplay=${MIN_NUMBER_OF_ROWS_TO_DISPLAY}
        .numberOfRowsAvailable=${numberOfObjectsDisplayed}
        .buttonText=${textButton}
        .navigateToSmartViewId=${this.payload?.inventorySmartViewId}
        .filterType="${FilterType.PROTOCOL}"
        .findingType="${FindingClassType.ARTIFACT}"
      >
      </gz-easm-generic-top-data>
    `;
  }

  protected handleResize(): void {
    super.handleResize();

    handleWidgetWithTopDataResize.call(this);
  }
}
